interface AppSubtitleProps {
  text: string;
}

export default function AppSubtitle({ text }: AppSubtitleProps) {
  return <p className="app-subtitle">{text}</p>;
}
